import CrudService from '@/api/CrudService';
import type { ProxyItem } from '@/types/order/proxy';

class ProxyService extends CrudService<ProxyItem> {
  constructor() {
    super('order/proxies');
  }
}

export default new ProxyService();
